export default "__VITE_PUBLIC_ASSET__9e1f1f46__"